import React, { ReactNode } from 'react';

export interface TabBarViewProps {
  /**
   * TabBarView id
   */
  id: string;
  /**
   * TabBar entry title
   */
  title: ReactNode;
  /**
   * View content shown when the tab is selected
   */
  children?: ReactNode;
}

/**
 * The `TabBarView` is a view that is shown when the corresponding tab is selected.
 */
export function TabBarView({
  title,
  children,
  ...props
}: TabBarViewProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof TabBarViewProps>) {
  return <div {...props}>{children}</div>;
}
